/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_User_InvalidInputs */

const en_error_user_invalid = /** @type {(inputs: Error_User_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user cannot be saved as it is: correct the field marked.`)
};

/**
* | output |
* | --- |
* | "The user cannot be saved as it is: correct the field marked." |
*
* @param {Error_User_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_user_invalid = /** @type {((inputs?: Error_User_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_User_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_user_invalid(inputs)
});